<template>
  <div class="related-links">
        <div class="related-links-elements" :class="{smAndUp: $vuetify.breakpoint.smAndUp, xs: $vuetify.breakpoint.xsOnly}">
            <div v-for="(task,i) in relatedTasksInElements" :key="task._id">
                <div class="related-elements-flex mb-1 mr-4" :class="{smAndUp: $vuetify.breakpoint.smAndUp}">
                    <div @click="toTask(task)" class="path pointer roboto-normal-16 clr-black">
                        {{task.parent_name}} - {{task.name}}
                        <v-btn @click.stop="deleteRelatedTaskForElements(task)" class="close_button" x-small icon><v-icon size="14">close</v-icon></v-btn> 
                    </div>
                </div>  
            </div>
            <div v-for="(sub,i) in relatedSubsInElements" :key="sub._id">
                <div class="related-elements-flex mb-1 mr-4" :class="{smAndUp: $vuetify.breakpoint.smAndUp}">
                    <div @click="toSub(sub)" class="path pointer roboto-normal-16 clr-black">
                        {{sub.parent_name}} - {{sub.name}}
                        <v-btn @click.stop="deleteRelatedSubForElements(sub)" class="close_button" x-small icon><v-icon size="14">close</v-icon></v-btn>
                    </div>
                </div>
            </div>   
        </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { relevantNotices, searchNotices } from '../../../helpers'
export default {
    name: 'RelatedLinks',
    props: ['element', 'deleteElementsInTask'],
    computed:{ 
        ...mapGetters(["themes", "current" ,"current_task", 'feeds', 'picked_sub']),
        allTasks() {
            return this.themes.map(theme => theme.tasks).flat()
        },
        allSubs() {
            return this.themes.map(theme => theme.tasks.map(task => task.subs).flat()).flat()
        },
        relatedTasksInElements() {
            return this.allTasks.filter(task => this.element && this.element.relatedTasks.some(id => id == task._id))
        },
        relatedSubsInElements() {
            return this.allSubs.filter(sub => this.element && this.element.relatedSubs.some(id => id == sub._id))
        },
    },
    methods: {
        ...mapMutations(['SET_CURRENT', 'TOGGLE_PICKED_SUB', 'SET_CURRENT_TASK']),
        ...mapActions(["setRelavantNotices", "deleteRelatedTaskInTask", "deleteRelatedSubInTask", "deleteRelatedTaskInSub", "deleteRelatedSubInSub"]),
        async deleteRelatedTaskForElements(task) {
            if(this.deleteElementsInTask) {
                await this.deleteRelatedTaskInTask({_id: this.current._id, task: this.element, related_task_id: task._id})
            } else {
                await this.deleteRelatedTaskInSub({_id: this.current._id, task: this.current_task, sub: this.element, related_task_id: task._id})
            }
        },
        async deleteRelatedSubForElements(sub) {
            if(this.deleteElementsInTask) {
                await this.deleteRelatedSubInTask({_id: this.current._id, task: this.element, related_sub_id: sub._id})
            } else {
                await this.deleteRelatedSubInSub({_id: this.current._id, task: this.current_task, sub: this.element, related_sub_id: sub._id})
            }
        },
        toTask(task) {
            const theme = this.themes.find(theme => {
                return theme.tasks.find(item => item._id == task._id)
            })
            this.SET_CURRENT(theme)
            this.setRelavantNotices(task)
            this.taskBody = task.body
            this.TOGGLE_PICKED_SUB({sub: this.picked_sub})
            this.$router.push(`/theme/${theme.route_name}/${task.route_name}`) 
        },
        toSub(sub) {
            const theme = this.themes.find(theme => {
                return theme.tasks.find(task => {
                    return task.subs.find(item => item._id == sub._id)
                })
            })
            const task = theme.tasks.find(task => {
                return task.subs.find(item => item._id == sub._id)
            })
            this.SET_CURRENT(theme)
            this.SET_CURRENT_TASK(task)
            const relNotices = relevantNotices(this.feeds, this.current_task)
            const relNoticesForSub = []
            searchNotices(relNotices, sub, relNoticesForSub)
            this.TOGGLE_PICKED_SUB({sub, relNotices, relNoticesForSub})
            this.taskBody = task.body
            this.$router.push(`/theme/${theme.route_name}/${task.route_name}`) 
        },
    }

}
</script>

<style lang="scss" scoped>
.related-links {
    .related-links-elements {
        display: flex;
        &.smAndUp {
            flex-wrap:wrap;
        }
        &.xs {
            width: 95vw;
            overflow-x: auto;
            overflow-y: hidden;
            -ms-overflow-style: -ms-autohiding-scrollbar;
            -webkit-overflow-scrolling: touch;
            white-space: nowrap;
            &::-webkit-scrollbar {
                display: none;
            }
        }
        .related-elements-flex {
            display: flex;
            align-items: center;
            &.smAndUp {
                // padding-top: 10px;
            }
            .path {
                background: #FFFDC7;
                border-radius: 14px;
                padding: 6px 16px;
                padding-right: 8px;
            } 
            .close_button{
                opacity: .7;
                &:hover{
                    opacity: 1;
                }
            }
        }
    }
}
</style>